<template>
  <div class="m-app">
    <slot />
  </div>
</template>

<script>
  export default {};
</script>
